import { Fragment, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navigation from "../Components/Navigation";
import Api from "../Services/Api";
import { Col, Container, Row, Table, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import RequireLoginComponent from "../Components/RequireLoginComponent";

interface Participant {
  id: number;
  healthFairId: number;
  userId: number;
  name: string;
  privacyPolicyAccepted: boolean;
  coffeeConsumption: boolean;
  cigarettesConsumption: boolean;
  sugarConsumption: boolean;
  weightKg: number;
  heightCm: number;
  bodyMassIndex: number;
  waistCm: number;
  waistHeightRatio: number;
  bodyWaterPercentage: number;
  muscleMassPercentage: number;
  bodyFatPercentage: number;
  systolic: number;
  diastolic: number;
  heartRate: number;
  glycatedHemoglobin: number;
  totalCholesterol: number;
  hdlCholesterol: number;
  ldlCholesterol: number;
  triglycerides: number;
  systolicDay2: number | null;
  diastolicDay2: number | null;
  heartRateDay2: number | null;
  startedAt: string;
  privacyPolicyAcceptedAt: string;
  finishedAt: string;
  startedDay2At: string | null;
  finishedDay2At: string | null;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    externalId: string;
    externalCompanyId: string;
    createdAt: string;
    updatedAt: string;
  };
}

const HealthFairParticipants = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const [participants, setParticipants] = useState<Participant[]>([]);
  const [isNotAuthenticated, setIsNotAuthenticated] = useState(false);

  useEffect(() => {
    window.rudderanalytics.page("Health Fair Participants");
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("staffToken");
    if (!token) {
      setIsNotAuthenticated(true);
    } else {
      setIsNotAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    if (!data && uuid) {
      const api = new Api();
      const participantsData = api.getHealthFairParticipants(uuid);
      participantsData
        .then((result) => {
          if (result) {
            setParticipants(result);
          }
        })
        .catch((ex) => {
          console.log(ex);
        });
      setData(true);
    }
  }, [data, uuid]);

  return (
    <Fragment>
      <Navigation />
      <Container className="mt-4">
        <RequireLoginComponent isNotAuthenticated={isNotAuthenticated} />
        
        {!isNotAuthenticated && (
          <>
            <Row>
              <Col>
                <Button variant="secondary" onClick={() => navigate("/health-fairs")} className="mb-3">
                  ← Back to Health Fairs
                </Button>
                <h1>Health Fair Participants</h1>
                <p className="text-muted">UUID: {uuid}</p>
                <p className="text-muted">Total Participants: {participants.length}</p>
              </Col>
            </Row>
            <Row className="mt-4">
              <Table bordered={false} striped={true} responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>External ID</th>
                    <th>Weight (kg)</th>
                    <th>Height (cm)</th>
                    <th>BMI</th>
                    <th>Waist (cm)</th>
                    <th>Waist Height Ratio</th>
                    <th>Body Fat %</th>
                    <th>Muscle Mass %</th>
                    <th>Blood Pressure</th>
                    <th>Heart Rate</th>
                    <th>HbA1c</th>
                    <th>Total Cholesterol</th>
                    <th>HDL</th>
                    <th>LDL</th>
                    <th>Triglycerides</th>
                  </tr>
                </thead>
                <tbody>
                  {participants.map((participant: Participant) => {
                    return (
                      <tr key={participant.id}>
                        <td><Link to={`/health-fairs/${uuid}/clinical-history/${participant.user.externalId}?name=${participant.name}&weightKg=${participant.weightKg}&heightCm=${participant.heightCm}`}>{participant.name}</Link></td>
                        <td>{participant.user.externalId}</td>
                        <td>{participant.weightKg}</td>
                        <td>{participant.heightCm}</td>
                        <td>{participant.bodyMassIndex}</td>
                        <td>{participant.waistCm}</td>
                        <td>{participant.waistHeightRatio}</td>
                        <td>{participant.bodyFatPercentage}</td>
                        <td>{participant.muscleMassPercentage}</td>
                        <td>{participant.systolic}/{participant.diastolic}</td>
                        <td>{participant.heartRate}</td>
                        <td>{participant.glycatedHemoglobin}</td>
                        <td>{participant.totalCholesterol}</td>
                        <td>{participant.hdlCholesterol}</td>
                        <td>{participant.ldlCholesterol}</td>
                        <td>{participant.triglycerides}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Row>
          </>
        )}
      </Container>
    </Fragment>
  );
};

export default HealthFairParticipants;

